import React, { memo } from 'react';

type Props = {
    children: React.ReactNode;
};

export const IconWrapper = memo(({ children }: Props) => (
    <span className="vss-icon-wrapper">
        {children}
    </span>
));
